module.exports = __webpack_public_path__ + "static/media/cards.c9a35f4a.JPG";